import React, { Fragment } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { faUsers, faCheck } from "@fortawesome/fontawesome-free-solid";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import WithToggle from "./WithToggle";
import WithFetchCustomers from "../containers/WithFetchCustomers/index";
import { get } from "lodash";
import CustomerButton from "./CustomerButton";
import {
  compose,
  setDisplayName,
  lifecycle,
  withHandlers,
  withProps
} from "recompose";
import Button from "./CustomButton";
import Card from "./Card";
import SearchCustomerForm from "./SearchCustomerForm";
import { connect } from "react-redux";
import { actions } from "../modules/customers";
import CustomerList from "./CustomerList";

let openCustomerButtonModal = null;

const CustomerTable = compose(
  setDisplayName("CustomerTable"),
  withProps({ fetchOnInit: false }),
  WithFetchCustomers,
  withHandlers({
    onSelectCustomer: ({ setCurrentCustomer, toggle }) => customer => ev => {
      setCurrentCustomer(customer);
      toggle();
    }
  })
)(({ customers, onSelectCustomer, ...props }) => (
  <CustomerList customers={customers}>
    {({ customer }) => (
      <Button
        fill={get(props, "currentCustomer.id", "") === customer.id}
        onClick={onSelectCustomer(customer)}
        color={
          get(props, "currentCustomer.id", "") === customer.id
            ? "primary"
            : "default"
        }
      >
        Select <FontAwesomeIcon icon={faCheck} />
      </Button>
    )}
  </CustomerList>
));

const EnhancedSearchCustomerForm = compose(
  setDisplayName("EnhancedSearchCustomerForm"),
  connect(
    null,
    {
      setCurrentCustomer: actions.setCurrentCustomer,
      resetState: actions.resetState
    }
  ),
  lifecycle({
    componentWillUnmount() {
      this.props.resetState(["currentCustomer"]);
    }
  }),
  withHandlers({
    onSearchCustomers: ({ setCurrentCustomer, hide }) => customers => {
      if (Array.isArray(customers)) {
        if (customers.length === 1) {
          setCurrentCustomer(customers[0]);
          hide();
        }
        if (customers.length === 0) {
          openCustomerButtonModal();
        }
      }
    }
  })
)(SearchCustomerForm);

const SelectCustomerButton = compose(
  WithToggle,
  setDisplayName("SelectCustomerButton"),
  lifecycle({
    componentDidMount() {
      const { show, defaultOpen } = this.props;
      defaultOpen && show();
    }
  })
)(props => {
  const { toggledOn, toggle, currentCustomer, hide } = props;
  return (
    <Fragment>
      <Modal isOpen={toggledOn} toggle={toggle} size="lg">
        <Card
          plain
          content={
            <div>
              <ModalHeader toggle={toggle}>
                <h3 className="title">Select Customer</h3>
              </ModalHeader>
              <ModalBody>
                <div className="row justify-content-between align-items-start">
                  <div className="col-lg-9">
                    <EnhancedSearchCustomerForm hide={hide} />
                  </div>
                  <div className="col-lg-3 px-sm-1">
                    <CustomerButton onCreate={props.toggle}>
                      {({ show }) => {
                        openCustomerButtonModal = show;
                      }}
                    </CustomerButton>
                  </div>
                </div>
                <CustomerTable {...props} />
              </ModalBody>
            </div>
          }
        />
      </Modal>
      <Button color="primary" onClick={toggle}>
        {`${!currentCustomer ? "Select" : "Change"} Customer`}{" "}
        <FontAwesomeIcon icon={faUsers} />
      </Button>
    </Fragment>
  );
});

export default SelectCustomerButton;
